import {setElementOnClick} from '../../ui_utils/DomUtils'

export class UILoadingRingController {
    private readonly loadingView: HTMLDivElement
    private readonly loadingRing: HTMLElement
    private readonly loadingError: HTMLParagraphElement
    private readonly errorRefreshButton: HTMLLinkElement

    constructor(base: string) {
        this.loadingView = document.getElementById(base + 'loading_ring_container') as HTMLDivElement
        this.loadingRing = document.getElementById(base + 'loading_ring') as HTMLElement
        this.loadingError = document.getElementById(base + 'loading_error') as HTMLParagraphElement
        this.errorRefreshButton = document.getElementById(base + 'loading_error_button') as HTMLLinkElement
    }

    hideLoading() {
        if(this.loadingView.style.display != 'none') this.loadingView.style.display = 'none'
    }

    showLoading() {
        if(this.loadingView.style.display != 'flex') this.loadingView.style.display = 'flex'
        if(this.loadingRing.style.display != 'block') this.loadingRing.style.display = 'block'
        if(this.loadingError.style.display != 'none') this.loadingError.style.display = 'none'
    }

    showLoadingError() {
        if(this.loadingView.style.display != 'flex') this.loadingView.style.display = 'flex'
        if(this.loadingRing.style.display != 'none') this.loadingRing.style.display = 'none'
        if(this.loadingError.style.display != 'block') this.loadingError.style.display = 'block'
        setElementOnClick(this.errorRefreshButton, () => location.reload())
    }
}
